S.showMoreElements = {
    config: {
        showAmount: 4,
        showAmountTablet: null,
        showAmountMobile: 3,
    },
    elements: {
        $showMore: null,
        $showMoreElement: null,
        $showMoreText: null,
    },

    init()
    {
        if (this.elements.$showMoreElement !== null)
        {
            if (this.elements.$showMoreElement.length > this.config.showAmount)
            {
                this.elements.$showMore.removeClass('is-hidden');
                this.$module.addClass('has-show-more');
                this.checkShowAmount();

                this.elements.$showMoreElement.each((index, element) =>
                {
                    const $element = $(element);

                    if (index >= this.showAmount)
                    {
                        return;
                    }

                    $element.removeClass('is-visb-hidden');
                });

                // init events
                this.initShowMoreEvents();

                // init resize
                this.addMqListener();
            }
            else
            {
                this.elements.$showMoreElement.removeClass('is-visb-hidden');
            }
        }
    },

    /**
     * set value
     */
    checkShowAmount()
    {
        // add listener
        if (S.mq('desktop').matches)
        {
            this.showAmount = this.config.showAmount;
        }
        else if (this.config.showAmountTablet !== null && S.mq('tablet').matches && !S.mq('desktop').matches)
        {
            this.showAmount = this.config.showAmountTablet;
        }
        else
        {
            this.showAmount = this.config.showAmountMobile;
        }

        return this.showAmount;
    },

    /**
     * init events for showMore
     */
    initShowMoreEvents()
    {
        this.elements.$showMore.on('click', (e) =>
        {
            if (this.elements.$showMore.hasClass('m-show-less'))
            {
                this.hideElements();
            }
            else
            {
                this.showElements();
            }

            this.handleShowMoreLogic();
        });
    },

    hideElements(amount = false)
    {
        const neededNumber = amount ? amount : this.checkShowAmount();

        if (this.elements.$showMoreElement !== null && this.elements.$showMoreElement.length)
        {
            $(this.elements.$showMoreElement.get().reverse()).each((index, element) =>
            {
                const $element = $(element);

                if (index >= (this.elements.$showMoreElement.length - neededNumber))
                {
                    $element.removeClass('is-visb-hidden');
                }
                else
                {
                    $element.addClass('is-visb-hidden');
                }
            });

            this.handleShowMoreLogic();
        }
    },

    showElements(amount = false)
    {
        const neededNumber = amount ? amount : this.checkShowAmount();

        if (this.elements.$showMoreElement !== null && this.elements.$showMoreElement.length)
        {
            const $hiddenElements = this.elements.$showMoreElement.filter('.is-visb-hidden');

            $hiddenElements.each((index, element) =>
            {
                const $element = $(element);

                if (index >= neededNumber)
                {
                    return;
                }

                $element.removeClass('is-visb-hidden');
            });
        }
    },

    handleShowMoreLogic()
    {
        if (!this.elements.$showMore.hasClass('.is-hidden'))
        {
            if (!this.elements.$showMoreElement.filter('.is-visb-hidden').length)
            {
                this.elements.$showMoreText.text('Weniger Anzeigen');
                this.elements.$showMore.addClass('m-show-less');
            }
            else
            {
                this.elements.$showMore.removeClass('m-show-less');
                this.elements.$showMoreText.text('Mehr Anzeigen');
            }
        }
    },

    /**
     * resize logic only for breakpoints
     */
    addMqListener()
    {
        S.mq('desktop').addListener((mq) =>
        {
            if (mq.matches)
            {
                this.hideElements();
            }
            else
            {
                this.hideElements();
            }
        });

        // add listener
        S.mq('tablet').addListener((e) =>
        {

            if (e.matches)
            {
                this.hideElements();
            }
            else
            {
                this.hideElements();
            }
        });
    },
};
